import { NSBarActionProps, NSBarAlertProps, NSBarTitleProps } from "namirasoft-site-react";
import { NSARouterMakerProps, NSALayout, NSALayoutPagesProps } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";

export interface NotificationSenderLayoutProps<EntityType extends { id: string }, EntityTypeInput = EntityType> extends NSARouterMakerProps
{
    action?: NSBarActionProps;
    title?: NSBarTitleProps;
    alerts?: NSBarAlertProps[];
    pages?: NSALayoutPagesProps<EntityType, EntityTypeInput>;
    edit?: () => void;
    delete?: () => void;
    redirectToView?: () => void;
    children: JSX.Element | JSX.Element[];
}

export function NotificationSenderLayout<EntityType extends { id: string } = any, EntityTypeInput = EntityType>(props: NotificationSenderLayoutProps<EntityType, EntityTypeInput>)
{
    return (
        <>
            <NSALayout
                product_id={ProductUUID.NAMIRASOFT_NOTIFICATION_SENDER}
                notifications={props.notifier.getNotifications()}
                action={props.action}
                title={props.title}
                pages={props.pages}
                account={props.account}
                url={props.url}
                notifier={props.notifier}
            >
                {props.children}
            </NSALayout>
        </>
    );
};